import { render, staticRenderFns } from "./StockItems.vue?vue&type=template&id=3128662d&scoped=true&"
import script from "./StockItems.vue?vue&type=script&lang=ts&"
export * from "./StockItems.vue?vue&type=script&lang=ts&"
import style0 from "./StockItems.vue?vue&type=style&index=0&id=3128662d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3128662d",
  null
  
)

export default component.exports